import dayjs from 'dayjs';

export const DATE_FORMATS = {
  DEFAULT: 'DD/MM/YYYY',
  WITH_TIME: 'DD/MM/YYYY HH:mm',
  SHORT: 'DD/MM/YY',
  FULL: 'DD/MM/YYYY HH:mm:ss',
  MONTH_YEAR: 'MM/YYYY',
};

export const formatWeekDayMonthTime = (dateString) => {
  const date = dayjs(dateString);
  const dayOfWeek = date.locale('en').format('ddd');
  const dayOfMonth = date.format('D');
  const time = date.format('h:mm A');
  return `${dayOfWeek}, ${dayOfMonth}, ${time}`;
};

export const useDateFormat = (
  date,
  format = DATE_FORMATS.DEFAULT,
  invalidText = 'Invalid date'
) => {
  return dayjs(date).isValid()
    ? dayjs(date).format(format)
    : invalidText;
};